import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeWhile } from 'rxjs/operators';

import {
  Patient,
  PatientData,
} from 'app/@core/interfaces/common/CalorieFriend/patients';

@Component({
  selector: 'ngx-patient-calendar-view',
  templateUrl: './patient-calendar-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PatientCalendarViewComponent implements OnInit {
  patient: Patient;

  private patientGuid: string = null;
  private loaded: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private patientService: PatientData,
    private cdRef: ChangeDetectorRef
  ) {
    this.cdRef.detach();
  }

  ngOnInit(): void {
    this.patientGuid = this.route.snapshot.paramMap.get('patientGuid');
    if (!this.patientGuid) return;

    this.patientService
      .get(null, this.patientGuid)
      .pipe(takeWhile(() => !this.loaded))
      .subscribe((patient) => {
        this.patient = patient;
        this.loaded = true;
        this.cdRef.reattach();
        this.cdRef.detectChanges();
      });
  }
}
